export default __webpack_public_path__ + "media/images/folder-icon-for-email-099b849d.svg";